import { FusaReply } from "@/types/replyTypes";
import { CreateProjectRequest, CreateProjectFromTemplateRequest, GetAllProjectsResponse, ProjectResponse, AssignRequirementToProjectResponse } from "../../types/projectTypes";
import { Client } from "./client";
import { ProjectParams } from "@/backend/access/project/types";

export class ProjectFrontendController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  getAllProjects(): Promise<GetAllProjectsResponse> {
    return this.client.read(`/api/projects/allForOrgMember`);
  }

  getAllProjectsForAdmin(): Promise<GetAllProjectsResponse> {
    return this.client.read('/api/projects/allForAdmin');
  }

  getRecentProjects(): Promise<GetAllProjectsResponse> {
    return this.client.read('/api/projects/recent');
  }

  recordProjectView(id: string): Promise<FusaReply> {
    return this.client.create(`/api/projects/${id}/views`, {});
  }

  getProjectsByParentId(parentId: string): Promise<GetAllProjectsResponse> {
    return this.client.read(`/api/projects/readByParentId/${parentId}`);
  }

  createProject(project: CreateProjectRequest): Promise<ProjectResponse> {
    return this.client.create('/api/projects', project);
  }

  updateProject(project: ProjectParams): Promise<ProjectResponse> {
    return this.client.update(`/api/projects/${project.id}`, project);
  }

  deleteProject(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/projects/${id}`);
  }

  readProject(id: string): Promise<ProjectResponse> {
    return this.client.read(`/api/projects/${id}`);
  }

  createProjectFromTemplate(data: CreateProjectFromTemplateRequest): Promise<ProjectResponse> {
    return this.client.create('/api/projects/from-template', data);
  }

  assignRequirements(projectId: string, requirementIds: string[]): Promise<AssignRequirementToProjectResponse> {
    return this.client.create(`/api/projects/${projectId}/requirements`, { requirementIds });
  }
}